<template>
  <div 
    class="fill-height">
    <v-dialog v-model="dialog.media"
      @keydown.esc="dialog.media = false"
      :fullscreen="dialog.fullscreen"
      width="800"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
        <v-card-title 
          class="d-flex align-center pa-4 text-right popup-header">
          <div
            class="title font-weight-bold">
            Media
          </div>

          <v-spacer/>

          <!-- <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon> -->

          <v-icon 
            @click="dialog.media = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/>

        <v-card-text 
          class="py-0 my-4">
          <div>
            <v-row>
              <v-col cols="3" v-for="(item, index) in details.media_arr" :key="index">
                <v-card flat style="cursor: pointer">
                  <div v-if="item.type === 'video'">
                    <v-img :src="item.img_url"
                      height="150"
                      cover
                      gradient="to top right, #0909098c, #00000099"
                      @click="selected.detail_media[0] = item; dialog.detail_media = true;"
                      class="ma-auto align-center">
                      <div class="d-flex align-center justify-center font-weight-black" style="width: 100%;">
                        <div class="text-center">
                          <v-icon size="30" color="#FFFFFF">mdi-play-circle</v-icon>
                          <div class="white--text fs-12">
                            Play Video
                          </div>
                        </div>
                      </div>
                    </v-img>
                  </div>
                  <div v-else>
                    <v-img :src="item.img_url"
                      height="150"
                      cover
                      @click="selected.detail_media[0] = item; dialog.detail_media = true;"
                      class="ma-auto align-center">
                    </v-img>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>

        </v-card-text>
        
        <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/>
          
        <v-card-actions
          class="pa-4">
          <v-spacer/>

          <v-btn
            @click="dialog.media = false;"
            width="120"
            outlined
            elevation="0"
            color="red"
            rounded
            class="body-2 font-weight-bold text-capitalize white--text">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.detail_media"
      @keydown.esc="dialog.detail_media = false"
      :fullscreen="dialog.fullscreen"
      v-if="dialog.detail_media"
      width="800"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
        <v-card-title 
          class="d-flex align-center pa-4 text-right popup-header">
          <div
            class="title font-weight-bold">
            Detail Media {{ selected.detail_media[0].title }}
          </div>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.detail_media = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/>

        <v-card-text 
          class="py-0 my-4">
          <div>
            <v-row>
              <v-col cols="12">
                <v-card flat>
                  <div v-if="selected.detail_media[0].type === 'video'">
                    <iframe width="100%" height="500" :src="`https://www.youtube.com/embed/${youtube_parser(selected.detail_media[0].url)}`" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  </div>
                  <div v-else>
                    <v-img :src="selected.detail_media[0].img_url"
                      height="80vh"
                      cover
                      class="ma-auto align-center">
                    </v-img>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>

        </v-card-text>
        
        <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/>
          
        <v-card-actions
          class="pa-4">
          <v-spacer/>

          <v-btn
            @click="dialog.detail_media = false;"
            width="120"
            outlined
            elevation="0"
            color="red"
            rounded
            class="body-2 font-weight-bold text-capitalize white--text">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-0 pr-1">
            <v-col
              cols="12" class="pb-1">
              <v-card
                to="/product"
                flat
                color="transparent"
                style="width: 20%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="20"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="kominfoklaten"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="16"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="fs-16 black--text ml-3"
                    style="font-weight: 600;">
                    Detail Fasilitas Umum
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pb-1 pt-1">
            <v-col 
              v-if="process.load"
              cols="12"
              class="py-0">
              <v-card flat>
                <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" 
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>
    
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>
              </v-card>
            </v-col>
            <v-col 
              v-if="!process.load"
              cols="12"
              class="py-0">
              <v-row>
                <v-col cols="12" md="9">
                  <v-card 
                    flat
                    style="border-radius: 10px; border: 1px solid #E7E7E7;">

                    <v-card-text>
                      <div class="fs-16 font_weight_600 black--text mb-5">
                        Informasi {{ details.name }}
                      </div>

                      <!-- <div>
                        <div class="d-flex align-center mt-0 mb-1">
                          <div>
                            <v-icon
                              color="green"
                              size="18"
                            >mdi-account-group</v-icon>
                          </div>
                          <div class="black--text text-lighten-1 fs-15 pt-1 ml-3">
                            3.000 Orang
                          </div>
                        </div>
                        <div class="d-flex align-start mt-0 mb-1">
                          <div>
                            <v-icon
                              color="#B71C1C"
                              size="18"
                            >mdi-map-marker</v-icon>
                          </div>
                          <div class="black--text fs-15 pt-1 ml-3">
                            Jl. Pemuda No.140, Sikenong, Kabupaten, Kec. Klaten Tengah, Kabupaten Klaten, Jawa Tengah 57414
                          </div>
                        </div>
                      </div> -->
                      <v-divider class="my-3"></v-divider>

                      <v-row
                        class="pa-0">
                        <v-col 
                          cols="12"
                          class="py-0">
                          <div>
                            <div class="font_weight_600 fs-14 black--text">
                              <div class="mb-2">
                                Kapasitas Fasilitas Umum
                              </div>
                            </div>
                            <div>
                              <div>
                                <v-row>
                                  <v-col cols="12" md="12" class="pt-0">
                                    <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                                      <tr>
                                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                          Konsep Acara
                                        </th>
                                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                          Kapasitas
                                        </th>
                                      </tr>
                                      <tr v-for="(item, i) in details.capacity_array" :key="i">
                                        <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; min-width: 300px;" class="black--text">
                                          {{ item.title }}
                                        </td>
                                        <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                          {{ item.value | number }}
                                        </td>
                                      </tr>
                                    </table>
                                  </v-col>
                                </v-row>
                              </div>
                              <div v-if="details.capacity_array.length == 0" class="text-center py-5">
                                <!-- <v-icon size="100" color="grey lighten-1">mdi-emoticon-sad-outline</v-icon> -->
                                <v-img 
                                  class="mx-auto"
                                  contain
                                  alt="vuetify"
                                  :width="40"
                                  :height="40"
                                  :src="require('@/assets/image/empty.png')">
                                </v-img>
                                <div class="fs-12 black--text">
                                  Kapasitas belum tersedia
                                </div>
                              </div>
                              <!-- <div class="d-flex align-center mt-0 mb-1">
                                <div>
                                  <v-icon
                                    color="#AD1457"
                                    size="16"
                                  >mdi-face-woman-shimmer</v-icon>
                                </div>
                                <div class="black--text text-lighten-1 fs-13 pt-1 ml-3">
                                  Tempat Rias
                                </div>
                              </div>
                              <div class="d-flex align-center mt-0 mb-1">
                                <div>
                                  <v-icon
                                    color="#1B5E20"
                                    size="16"
                                  >mdi-forest</v-icon>
                                </div>
                                <div class="black--text text-lighten-1 fs-13 pt-1 ml-3">
                                  Halaman Depan
                                </div>
                              </div> -->
                            </div>
                          </div>
                        </v-col>
                      </v-row>
            
                      <v-divider class="my-3"></v-divider>
            
                      <fasilitas />
            
            
                      <v-divider class="my-3"></v-divider>
            
                      <div>
                        <div class="font_weight_600 fs-14 black--text mb-3">
                          <div>
                            Deskripsi
                          </div>
                        </div>
                        <div class="black--text fs-13">
                          <p>
                            {{ details.desc }}
                          </p>
                        </div>
                      </div>

                      <v-divider class="my-3"></v-divider>

                      <jenis /> 
            
                      <!-- <div>
                        <div class="font_weight_600 fs-14 black--text mb-3">
                          <div>
                            Jenis & Harga disewa
                          </div>
                        </div>

                        <div>
                          <v-row>
                            <v-col cols="12" md="6" class="pt-0">
                              <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                                <tr>
                                  <th colspan="2" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                    Fasilitas Umum, kamar Rias dan Halaman
                                  </th>
                                </tr>
                                <tr>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 280px; min-width: 280px; max-width: 280px;" class="black--text">
                                    Pribadi / Perhelatan / Pernikahan
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 0px; text-align: left; width: 100%;" class="black--text">
                                    <table style="width: 100%; border-collapse: collapse;">
                                      <tr style="border-bottom: 1px solid #ededed;">
                                        <div class="px-3 py-1">
                                          <div class="fs-10">
                                            Hari sabtu / minggu / hari libur nasional
                                          </div>
                                          <div>
                                            Rp 7.500.000
                                          </div>
                                        </div>
                                      </tr>
                                      <tr>
                                        <div class="px-3 py-1">
                                          <div class="fs-10">
                                            Selain hari diatas
                                          </div>
                                          <div>
                                            Rp 4.500.000
                                          </div>
                                        </div>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 280px; min-width: 280px; max-width: 280px;" class="black--text">
                                    Organisasi Sosial Kemasyarakatan
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 0px; text-align: left; width: 100%;" class="black--text">
                                    <table style="width: 100%; border-collapse: collapse;">
                                      <tr>
                                        <div class="px-3 py-1">
                                          <div>
                                            Rp 2.000.000
                                          </div>
                                        </div>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 280px; min-width: 280px; max-width: 280px;" class="black--text">
                                    Organisasi Pendidikan
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 0px; text-align: left; width: 100%;" class="black--text">
                                    <table style="width: 100%; border-collapse: collapse;">
                                      <tr>
                                        <div class="px-3 py-1">
                                          <div>
                                            Rp 1.500.000
                                          </div>
                                        </div>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </v-col>

                            <v-col cols="12" md="6" class="pt-0">
                              <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                                <tr>
                                  <th colspan="2" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                    Halaman Tanpa Listrik
                                  </th>
                                </tr>
                                <tr>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 280px; min-width: 280px; max-width: 280px;" class="black--text">
                                    Event Musik / Pertunjukan
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 0px; text-align: left; width: 100%;" class="black--text">
                                    <table style="width: 100%; border-collapse: collapse;">
                                      <tr>
                                        <div class="px-3 py-1">
                                          <div>
                                            Rp 1.000.000
                                          </div>
                                        </div>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 280px; min-width: 280px; max-width: 280px;" class="black--text">
                                    Olahraga
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 0px; text-align: left; width: 100%;" class="black--text">
                                    <table style="width: 100%; border-collapse: collapse;">
                                      <tr>
                                        <div class="px-3 py-1">
                                          <div>
                                            Rp 500.000
                                          </div>
                                        </div>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 280px; min-width: 280px; max-width: 280px;" class="black--text">
                                    Panggung
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 0px; text-align: left; width: 100%;" class="black--text">
                                    <table style="width: 100%; border-collapse: collapse;">
                                      <tr>
                                        <div class="px-3 py-1">
                                          <div>
                                            Rp 500.000
                                          </div>
                                        </div>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </v-col>
                          </v-row>
                        </div>
                      </div> -->

                      <v-divider class="my-3"></v-divider>
            
                      <div>
                        <div class="font_weight_600 fs-14 black--text mb-3">
                          <div>
                            Tanggal Booking
                          </div>
                        </div>
                        <div>
                          <v-row>
                            <v-col class="pt-0">
                              <v-sheet height="64">
                                <v-toolbar
                                  flat
                                >
                                  <v-btn
                                    outlined
                                    class="mr-4"
                                    color="grey darken-2"
                                    @click="setToday"
                                  >
                                    Today
                                  </v-btn>
                                  <v-btn
                                    fab
                                    text
                                    small
                                    color="grey darken-2"
                                    @click="prev"
                                  >
                                    <v-icon small>
                                      mdi-chevron-left
                                    </v-icon>
                                  </v-btn>
                                  <v-btn
                                    fab
                                    text
                                    small
                                    color="grey darken-2"
                                    @click="next"
                                  >
                                    <v-icon small>
                                      mdi-chevron-right
                                    </v-icon>
                                  </v-btn>
                                  <v-toolbar-title v-if="$refs.calendar">
                                    {{ $refs.calendar.title }}
                                  </v-toolbar-title>
                                  <v-spacer></v-spacer>
                                  <v-menu
                                    bottom
                                    right
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        outlined
                                        color="grey darken-2"
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        <span>{{ typeToLabel[type] }}</span>
                                        <v-icon right>
                                          mdi-menu-down
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                    <v-list>
                                      <v-list-item @click="type = 'day'">
                                        <v-list-item-title>Day</v-list-item-title>
                                      </v-list-item>
                                      <v-list-item @click="type = 'week'">
                                        <v-list-item-title>Week</v-list-item-title>
                                      </v-list-item>
                                      <v-list-item @click="type = 'month'">
                                        <v-list-item-title>Month</v-list-item-title>
                                      </v-list-item>
                                      <v-list-item @click="type = '4day'">
                                        <v-list-item-title>4 days</v-list-item-title>
                                      </v-list-item>
                                    </v-list>
                                  </v-menu>
                                </v-toolbar>
                              </v-sheet>
                              <v-sheet height="600">
                                <v-calendar
                                  ref="calendar"
                                  v-model="focus"
                                  color="primary"
                                  :events="events"
                                  :event-color="getEventColor"
                                  :type="type"
                                  @click:event="showEvent"
                                  @click:more="viewDay"
                                  @click:date="viewDay"
                                  @change="updateRange"
                                ></v-calendar>
                                <v-menu
                                  v-model="selectedOpen"
                                  :close-on-content-click="false"
                                  :activator="selectedElement"
                                  offset-x
                                >
                                  <v-card
                                    color="grey lighten-4"
                                    min-width="350px"
                                    flat
                                  >
                                    <v-toolbar
                                      :color="selectedEvent.color"
                                      dark
                                    >
                                      <v-btn icon>
                                        <v-icon>mdi-pencil</v-icon>
                                      </v-btn>
                                      <v-toolbar-title>{{ selectedEvent.name }}</v-toolbar-title>
                                      <v-spacer></v-spacer>
                                      <v-btn icon>
                                        <v-icon>mdi-heart</v-icon>
                                      </v-btn>
                                      <v-btn icon>
                                        <v-icon>mdi-dots-vertical</v-icon>
                                      </v-btn>
                                    </v-toolbar>
                                    <v-card-text>
                                      <span v-html="selectedEvent.details"></span>
                                    </v-card-text>
                                    <v-card-actions>
                                      <v-btn
                                        text
                                        color="secondary"
                                        @click="selectedOpen = false"
                                      >
                                        Cancel
                                      </v-btn>
                                    </v-card-actions>
                                  </v-card>
                                </v-menu>
                              </v-sheet>
                            </v-col>
                          </v-row>
                        </div>
                      </div>

                      <v-divider class="my-3"></v-divider>
            
                      <div>
                        <div class="font_weight_600 fs-14 black--text mb-3">
                          <div>
                            Map
                          </div>
                        </div>
                        <div>
                          <gmap-map
                            :center="{ lat: (details.latitude*1), lng: (details.longitude*1) }"
                            :zoom="16"
                            :options="{
                              zoomControl: true,
                              mapTypeControl: false,
                              scaleControl: false,
                              streetViewControl: false,
                              rotateControl: false,
                              fullscreenControl: true,
                              disableDefaultUi: false
                            }"
                            style="width: 100%; height: 300px;">

                            <gmap-marker
                              :position="{ lat: (details.latitude*1), lng: (details.longitude*1) }">
                            </gmap-marker>
                          </gmap-map>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="3">
                  <v-card 
                    flat
                    style="border-radius: 10px; border: 1px solid #E7E7E7; border-radius: 6px; position: sticky; top: 78px;">

                    <v-card-text>
                      <div>
                        <v-img :src="details.media_arr[0].img_url"
                          height="250"
                          cover
                          @click="dialog.media = true"
                          gradient="to top right, #0909098c, #00000099"
                          class="ma-auto align-center"
                          style="cursor: pointer">
                          <div class="d-flex align-center justify-center font-weight-black" style="width: 100%;">
                            <div class="text-center">
                              <v-icon size="50" color="#FFFFFF">mdi-play-circle</v-icon>
                              <div class="white--text fs-14">
                                Lihat Media
                              </div>
                            </div>
                          </div>
                        </v-img>
                      </div>
                      <!-- <div class="mt-0">
                        <div class="grey--text text--darken-4 text-lighten-1 fs-13 pb-1">
                          Harga Pemakaian / Penggunaan Per Hari
                        </div>
                        <div class="font_weight_600 fs-20 text-gray-900">
                          Rp 500.000 s/d Rp 4.500.000
                        </div>
                      </div> -->

                      <div class="fs-18 font_weight_600 black--text mt-3 pb-1">
                        {{ details.name }}
                      </div>

                      <div>
                        <!-- <div class="d-flex align-center mt-0 mb-1">
                          <div>
                            <v-icon
                              color="green"
                              size="18"
                            >mdi-account-group</v-icon>
                          </div>
                          <div class="black--text text-lighten-1 fs-13 pt-1 ml-3">
                            {{ details.capacity | number }} Orang
                          </div>
                        </div> -->
                        <div class="d-flex align-start mt-0 mb-1">
                          <div>
                            <v-icon
                              color="#B71C1C"
                              size="18"
                            >mdi-map-marker</v-icon>
                          </div>
                          <div class="black--text fs-13 pt-1 ml-3">
                            {{ details.address }}
                          </div>
                        </div>
                      </div>

                      <v-divider class="my-2"></v-divider>

                      <v-row>
                        <v-col 
                          cols="12"
                          md="6"
                          class="d-flex align-center justify-end py-0">
                          
                          <v-btn
                            :to="`/product/edit/${this.$route.params.id}?form=detail`"
                            :disabled="process.form"
                            color="blue"
                            elevation="0"
                            block
                            class="fs-13 white--text text-capitalize d-flex align-center ml-4"
                            style="font-weight: 600; border-radius: 6px;">
                            <v-icon 
                              size="16">
                              mdi-square-edit-outline
                            </v-icon>
            
                            <span
                              class="ml-2">
                              Ubah
                            </span>
                          </v-btn>
                        </v-col>
                        <v-col 
                          cols="12"
                          md="6"
                          class="d-flex align-center justify-end py-0">
                          
                          <v-btn
                            to="/product"
                            :disabled="process.form"
                            color="red"
                            elevation="0"
                            block
                            class="fs-13 white--text text-capitalize d-flex align-center ml-4"
                            style="font-weight: 600; border-radius: 6px;">
                            <v-icon 
                              size="16">
                              mdi-progress-close
                            </v-icon>
            
                            <span
                              class="ml-2">
                              Kembali
                            </span>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>

                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>
  
<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  
  export default {
    data: () => ({
      focus: '',
      dialog: {
        media: false,
        fullscreen: false,
        detail_media: false
      },
      type: 'month',
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        '4day': '4 Days',
      },
      details: {},
      selected: {
        detail_media: []
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      process: {
        form: false,
        submit: false,
        delete: false,
        load: false
      },
    }),
    components: {
      fasilitas: () => import(/* webpackPrefetch: true */ '@/components/product/fasilitas.vue'),
      jenis: () => import(/* webpackPrefetch: true */ '@/components/product/jenis.vue'),
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      // this.$refs.calendar.checkChange()
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }
        await get(`admin/product/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.details = res.results.data
            this.details.media_arr = JSON.parse(res.results.data.media_arr)
            this.process.form = false
          }
        })
      },
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      youtube_parser(url){
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match&&match[7].length==11)? match[7] : false;
      },
      updateRange ({ start, end }) {
        const events = []

        const min = new Date(`${start.date}T00:00:00`)
        const max = new Date(`${end.date}T23:59:59`)
        const days = (max.getTime() - min.getTime()) / 86400000
        const eventCount = this.rnd(days, days + 20)

        for (let i = 0; i < eventCount; i++) {
          const allDay = this.rnd(0, 3) === 0
          const firstTimestamp = this.rnd(min.getTime(), max.getTime())
          const first = new Date(firstTimestamp - (firstTimestamp % 900000))
          const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
          const second = new Date(first.getTime() + secondTimestamp)

          events.push({
            name: this.names[this.rnd(0, this.names.length - 1)],
            start: first,
            end: second,
            color: this.colors[this.rnd(0, this.colors.length - 1)],
            timed: !allDay,
          })
        }

        this.events = events
      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
    },
  }
</script>